import More from './More';

export default More;
